/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_File_HelpInputs */

const en_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a video file to export with AD`)
};

const fr_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un fichier vidéo à exporter avec l'AD`)
};

const de_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Videodatei aus, die mit AD exportiert werden soll.`)
};

const it_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un file video da esportare con AD`)
};

const ru_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите видеофайл для экспорта с помощью AD.`)
};

const es_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un archivo de vídeo para exportar con AD`)
};

const zh_cn2_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要使用 AD 导出的视频文件`)
};

const ja_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADでエクスポートするビデオファイルを選択`)
};

const hi_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD के साथ निर्यात करने के लिए एक वीडियो फ़ाइल चुनें`)
};

const pt_pt2_audio_description_export_video_file_help = /** @type {(inputs: Audio_Description_Export_Video_File_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um arquivo de vídeo para exportar com o AD.`)
};

/**
* | output |
* | --- |
* | "Select a video file to export with AD" |
*
* @param {Audio_Description_Export_Video_File_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_file_help = /** @type {((inputs?: Audio_Description_Export_Video_File_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_File_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_video_file_help(inputs)
	if (locale === "de") return de_audio_description_export_video_file_help(inputs)
	if (locale === "it") return it_audio_description_export_video_file_help(inputs)
	if (locale === "ru") return ru_audio_description_export_video_file_help(inputs)
	if (locale === "es") return es_audio_description_export_video_file_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_video_file_help(inputs)
	if (locale === "ja") return ja_audio_description_export_video_file_help(inputs)
	if (locale === "hi") return hi_audio_description_export_video_file_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_video_file_help(inputs)
	return en_audio_description_export_video_file_help(inputs)
});